import { BreakpointObserver } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { readCssVariable } from "../utils/read-css-variable";

@Injectable({
  providedIn: "root"
})
export class BreakpointsService {

  ionicBreakpoints = {
    xs: readCssVariable({
      element: window.document.body,
      variableName: '--screen-breakpoints-xs'
    }),
    sm: readCssVariable({
      element: window.document.body,
      variableName: '--screen-breakpoints-sm'
    }),
    md: readCssVariable({
      element: window.document.body,
      variableName: '--screen-breakpoints-md'
    }),
    lg: readCssVariable({
      element: window.document.body,
      variableName: '--screen-breakpoints-lg'
    }),
    xl: readCssVariable({
      element: window.document.body,
      variableName: '--screen-breakpoints-xl'
    })
  }


  constructor(private breakpointObserver: BreakpointObserver) {}

  getLargeBreakpointObserver() {
    return this.breakpointObserver.observe([
      `(min-width: ${this.ionicBreakpoints.lg})`
    ])
  }

  isAboveLargeScreen() {
    return this.breakpointObserver.isMatched(`(min-width: ${this.ionicBreakpoints.lg})`);
  }
}
